import { render, staticRenderFns } from "./yyConfig.vue?vue&type=template&id=56208c58&scoped=true"
import script from "./yyConfig.vue?vue&type=script&lang=js"
export * from "./yyConfig.vue?vue&type=script&lang=js"
import style0 from "./yyConfig.vue?vue&type=style&index=0&id=56208c58&prod&lang=less"
import style1 from "./yyConfig.vue?vue&type=style&index=1&id=56208c58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56208c58",
  null
  
)

export default component.exports